import { AffiliateEnums } from "@_types/affiliates/Affiliates.enums";
import { OfferConstants } from "./IOffer";

export namespace AffiliateConstants {
  export enum Status {
    PENDING = "PENDING",
    APPROVED = "APPROVED",
    REFUSED = "REFUSED",
    CANCELED = "CANCELED",
    INACTIVE = "INACTIVE",
  }

  export enum CanceledBy {
    AFFILIATE = "AFFILIATE",
    PRODUCER = "PRODUCER",
    MANAGER = "MANAGER",
  }

  export const PermitedMarketPlaceStatus = ["APPROVED", "PENDING"];
}

export namespace AffiliateSettingsConstants {
  export enum RecurrenceChargeTypes {
    ALL_CHARGES = "ALL_CHARGES",
    FIRST_CHARGE = "FIRST_CHARGE",
    FIXED_NUMBER = "FIXED_NUMBER",
  }

  export const RecurrenceChargeTypesLabel = {
    [AffiliateSettingsConstants.RecurrenceChargeTypes.ALL_CHARGES]: "Todas as cobranças",
    [AffiliateSettingsConstants.RecurrenceChargeTypes.FIRST_CHARGE]: "Somente para primeira cobrança",
    [AffiliateSettingsConstants.RecurrenceChargeTypes.FIXED_NUMBER]: "Número fixo",
  };

  export enum RecurrenceChargeValueRange {
    MIN = 1,
    MAX = 99,
  }

  export enum CommissionPreference {
    FIRST_CLICK = "FIRST_CLICK",
    LAST_CLICK = "LAST_CLICK",
  }

  export enum CookiesLifetime {
    ONE_DAY = "ONE_DAY",
    SEVEN_DAYS = "SEVEN_DAYS",
    THIRTY_DAYS = "THIRTY_DAYS",
    SIXTY_DAYS = "SIXTY_DAYS",
    NINETY_DAYS = "NINETY_DAYS",
    LIFETIME = "LIFETIME",
  }

  export enum MarketplaceEvaluationStatus {
    APPROVED = "APPROVED",
    IN_REVIEW = "IN_REVIEW",
    PENDING = "PENDING",
    REFUSED = "REFUSED",
  }

  export const cookieLifetimeValue = {
    [CookiesLifetime.SEVEN_DAYS]: 7,
    [CookiesLifetime.THIRTY_DAYS]: 30,
    [CookiesLifetime.SIXTY_DAYS]: 60,
    [CookiesLifetime.NINETY_DAYS]: 90,
    [CookiesLifetime.LIFETIME]: 0,
  };

  export const CookiesLifetimeLabel = {
    [AffiliateSettingsConstants.CookiesLifetime.ONE_DAY]: "1 dia",
    [AffiliateSettingsConstants.CookiesLifetime.SEVEN_DAYS]: "7 dias",
    [AffiliateSettingsConstants.CookiesLifetime.THIRTY_DAYS]: "30 dias",
    [AffiliateSettingsConstants.CookiesLifetime.SIXTY_DAYS]: "60 dias",
    [AffiliateSettingsConstants.CookiesLifetime.NINETY_DAYS]: "90 dias",
    [AffiliateSettingsConstants.CookiesLifetime.LIFETIME]: "Vitalício",
  };
}

export type AffiliatesResponseType = {
  uuid: string;
  userAffiliateName: string;
  userAffiliateEmail: string;
  affiliateStatus: AffiliateConstants.Status;
  salesCount: number;
  salesIncome: number;
  recurrenceCommission: number;
  oneTimeCommission: number;
  recurrenceChargeTypes: AffiliateSettingsConstants.RecurrenceChargeTypes;
  recurrenceFixedCharge?: number;
};

export type ListAffiliatesResponseType = {
  meta: {
    page: number;
    pages: number;
    pageSize: number;
    total: number;
  };
  data: AffiliatesResponseType[];
};

type AffiliateSettingsPlan = {
  uuid: string;
  name: string;
  frequency: OfferConstants.ChargeFrequency;
  value: number;
  transactionFee: number;
};

export type AffiliateSettingsOfferResponseType = {
  uuid: string;
  name: string;
  value: number;
  billlingType: OfferConstants.BillingType;
  isFree: boolean;
  fee: number;
  transactionFee: number;
  plans?: AffiliateSettingsPlan[];
};

export type AffiliateSettingsDataType = {
  automaticAffiliateEnabled: boolean;
  extendedCommissionEnabled: boolean;
  shareCustomerDataEnabled: boolean;
  oneTimeCommission: number;
  recurrenceCommission: number;
  recurrenceChargeTypes: AffiliateSettingsConstants.RecurrenceChargeTypes;
  commissionPreference: AffiliateSettingsConstants.CommissionPreference;
  cookieLifetime: number;
  recurrenceFixedCharge?: number;
  supportName: string;
  supportEmail: string;
  supportPhone: string;
  supportPage: string;
  supportRules: string;
  marketplaceEnabled: boolean;
  marketplaceEvaluationStatus?: AffiliateSettingsConstants.MarketplaceEvaluationStatus;
  marketplaceEvaluationRefusedReason?: string | null;
};

export type AffiliateSettingsResponseType = {
  productUuid: string;
  commissionPreference?: AffiliateSettingsConstants.CommissionPreference;
  cookieLifetime?: number;
  offers: string[];
  affiliatesEnabled: boolean;
  affiliateSettings: AffiliateSettingsDataType | null;
  isMarketplacePublishable?: boolean;
  marketplaceStatus: AffiliateEnums.MarketplaceStatus | null;
};
